var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.95 9H20.05C17.755 9 16 10.8056 16 13.1667V24.2778C16 26.5 17.755 28.4444 20.05 28.4444H33.55L38.95 34V28.4444C41.245 28.4444 43 26.5 43 24.2778V13.1667C43 10.8056 41.245 9 38.95 9Z",
    fill: "#0473EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.95 0H4.05C1.755 0 0 1.73333 0 4V14.6667C0 16.8 1.755 18.6667 4.05 18.6667V24L9.45 18.6667H13.5V13.3333C13.5 9.6 16.47 6.66667 20.25 6.66667H27V4C27 1.73333 25.245 0 22.95 0Z",
    fill: "#38D200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5a768ca29932375f6d841f30499fb83f.svg";
export { ForwardRef as ReactComponent };